import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { makeSearchPath, reportsPath } from '@/utils'
import { ReportNode } from '@/apollo/graphql'

interface IReportRow {
  node: ReportNode
}

const ReportRow: React.FC<IReportRow> = ({ node }) => {
  const navigate = useNavigate()
  const { customerId } = useParams()

  return (
    <tr
      onClick={() =>
        navigate(
          makeSearchPath(reportsPath, {
            customerId,
            id: node.id,
          }),
        )
      }
    >
      <td>{node.id}</td>
      <td>{node.reportNumber}</td>
      <td>{node.carNumber}</td>
    </tr>
  )
}

export default ReportRow
